import React, { useState } from "react";
import { Link } from "react-router-dom";
import styles from "./ForgotPassword.module.css";
import api from "../../services/api";
import logo from "../../assets/logo_nexus_sem_fundo.png";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [touched, setTouched] = useState(false);

  const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i.test(email);
  const showError = touched && !isValidEmail;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setTouched(true);
    if (!isValidEmail) return;

    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
    } catch {
      // Silencia o erro — não revelamos se o e-mail existe
    } finally {
      setLoading(false);
      setSent(true);
    }
  };

  return (
    <div className={styles.page}>
      <div className={styles.bgDecor} aria-hidden="true" />
      <div className={styles.container}>
        <div className={styles.card}>
          {/* Header */}
          <div className={styles.brandRow}>
            <div className={styles.logoStub}>
              <img src={logo} alt="Nexus Tech" className={styles.logoImg} />
            </div>
            <div className={styles.brandText}>
              <strong className={styles.brandName}>Nexus Tech</strong>
              <span className={styles.brandTag}>Recuperação de acesso</span>
            </div>
          </div>

          <h1 className={styles.title}>Esqueci minha senha</h1>
          <p className={styles.subtitle}>
            Informe seu e-mail cadastrado e enviaremos as instruções de
            recuperação.
          </p>

          {sent ? (
            <div className={styles.successBox} role="alert" aria-live="polite">
              <span className={styles.successIcon} aria-hidden="true">✉️</span>
              <p>
                Se este e-mail estiver cadastrado, você receberá as instruções
                em breve. Verifique também sua caixa de spam.
              </p>
            </div>
          ) : (
            <form className={styles.form} noValidate onSubmit={handleSubmit}>
              <div className={styles.field}>
                <label htmlFor="email" className={styles.label}>
                  E-mail
                </label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  className={`${styles.input} ${showError ? styles.inputError : ""}`}
                  placeholder="voce@exemplo.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  onBlur={() => setTouched(true)}
                  aria-invalid={showError}
                  aria-describedby={showError ? "email-error" : undefined}
                  autoComplete="email"
                  disabled={loading}
                />
                {showError && (
                  <span id="email-error" className={styles.errorText}>
                    Informe um e-mail válido.
                  </span>
                )}
              </div>

              <button
                type="submit"
                className={styles.primaryBtn}
                disabled={loading}
                aria-busy={loading}
              >
                {loading ? (
                  <>
                    <span className={styles.spinner} aria-hidden="true" />
                    Enviando...
                  </>
                ) : (
                  "Enviar instruções"
                )}
              </button>
            </form>
          )}

          <div className={styles.backRow}>
            <Link to="/registration" className={styles.backLink}>
              ← Voltar para o login
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
